(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const swatchWrappers = document.querySelectorAll('product-swatches');

    swatchWrappers.forEach((wrapper) => {
      let lockedScrollY = 0;
      let isRestoring = false;

      const saveScroll = () => {
        if (isRestoring) return;
        lockedScrollY = window.scrollY || window.pageYOffset;
      };

      const restoreScroll = () => {
        isRestoring = true;

        window.scrollTo({
          top: lockedScrollY,
          left: 0,
          behavior: 'instant'
        });

        requestAnimationFrame(() => {
          window.scrollTo({
            top: lockedScrollY,
            left: 0,
            behavior: 'instant'
          });

          setTimeout(() => {
            isRestoring = false;
          }, 50);
        });
      };

      wrapper.addEventListener('pointerdown', (event) => {
        if (
          event.target.closest('label') ||
          event.target.closest('input') ||
          event.target.closest('button')
        ) {
          saveScroll();
        }
      });

      wrapper.addEventListener('click', (event) => {
        if (
          event.target.closest('label') ||
          event.target.closest('input') ||
          event.target.closest('button')
        ) {
          saveScroll();
        }
      });

      wrapper.addEventListener('change', (event) => {
        if (event.target.matches('input')) {
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }

          restoreScroll();

          setTimeout(() => {
            restoreScroll();
          }, 120);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
